import { pixelPurchase } from "@/lib/pixel";
import { gtmEvent } from "@/lib/gtm";

/**
 * Registra la compra (Meta + GA4) UNA sola vez por orden.
 *
 * Por qué: el evento de compra se emitía en más de un punto del checkout
 * (al crear la orden y al volver del pago), lo que duplicaba el conteo, y la
 * ruta de tarjeta no emitía nada. Este helper centraliza el disparo y lo hace
 * idempotente por `orderId` con sessionStorage.
 */

const KEY_PREFIX = "vv_purchase_";

export const firePurchaseOnce = (params: {
  orderId: string;
  value: number;
  paymentType?: string;
}): void => {
  const { orderId, value, paymentType } = params;
  if (!orderId) return;

  const key = KEY_PREFIX + orderId;
  try {
    if (window.sessionStorage.getItem(key)) return;
    window.sessionStorage.setItem(key, "1");
  } catch {
    // sessionStorage bloqueado (modo privado / iframe): se emite igual,
    // sin dedupe, en vez de perder la conversión.
  }

  pixelPurchase({ value, order_id: orderId });
  gtmEvent("purchase", {
    transaction_id: orderId,
    currency: "USD",
    value,
    ...(paymentType ? { payment_type: paymentType } : {}),
  });
};
